import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FelhasznalokOldal from './FelhasznalokOldal';
import RendezvenyekOldal from './RendezvenyekOldal';
import MegrendelesekOldal from './MegrendelesekOldal';
import AttekintoSablonokOldal from './AttekintoSablonokOldal';

// Az admin oldalak menüje. Új admin oldal felvétele: egy sor ide + egy komponens.
//   szukseges: 'olvaso' (admin és auditor), 'foadmin' (csak a főadmin) vagy 'foadmin_vagy_auditor'
//   (a Felhasználók: a főadmin kezeli, az auditor csak olvassa)
// A kliens csak a megjelenítést dönti el; a tartalmat adó hívásokat a szerver is ellenőrzi.
export const ADMIN_MENU = [
    { id: 'rendezvenyek', felirat: 'Rendezvények', ikon: 'fa-calendar-days', szukseges: 'olvaso', Komponens: RendezvenyekOldal },
    { id: 'megrendelesek', felirat: 'Megrendelések', ikon: 'fa-receipt', szukseges: 'olvaso', Komponens: MegrendelesekOldal },
    { id: 'attekinto_sablonok', felirat: 'Sablonok', ikon: 'fa-file-lines', szukseges: 'foadmin', Komponens: AttekintoSablonokOldal },
    { id: 'felhasznalok', felirat: 'Felhasználók', ikon: 'fa-users', szukseges: 'foadmin_vagy_auditor', Komponens: FelhasznalokOldal },
];

function latja(felhasznalo, menupont) {
    if (menupont.szukseges === 'foadmin') {
        return felhasznalo.foadmin === true;
    }
    if (menupont.szukseges === 'foadmin_vagy_auditor') {
        return felhasznalo.foadmin === true || felhasznalo.auditor === true;
    }
    return felhasznalo.admin === true || felhasznalo.auditor === true;
}

export default function AdminOldal({ felhasznalo, onKilepes, callAPI, getCommInProgress }) {
    const navigate = useNavigate();
    const [kivalasztottID, setKivalasztottID] = useState(undefined);

    // Nem admin vagy nincs belépve (vendég): vissza a rendezvényekhez.
    // Újratöltéskor a felhasználó betöltéséig (undefined) várunk.
    useEffect(() => {
        if (felhasznalo === null || (felhasznalo !== undefined && !felhasznalo.admin && !felhasznalo.auditor)) {
            navigate('/rendezvenyek', { replace: true });
        }
    }, [felhasznalo]);

    if (felhasznalo === undefined || felhasznalo === null || (!felhasznalo.admin && !felhasznalo.auditor)) {
        return <div />;
    }

    const menu = ADMIN_MENU.filter(function (m) { return latja(felhasznalo, m); });
    const aktiv = menu.find(function (m) { return m.id === kivalasztottID; }) || menu[0];

    return (
        <div className="adminOldal">
            <div className="adminKeret">
                <div className="adminMenu" role="tablist">
                    <button type="button" className="adminVissza" onClick={function () { navigate('/rendezvenyek'); }}>
                        <FontAwesomeIcon icon="fa-arrow-left" /> Vissza a rendezvényekhez
                    </button>
                    <div className="adminCim">Adminisztráció</div>
                    {menu.map(function (m) {
                        return (
                            <button
                                key={m.id}
                                type="button"
                                role="tab"
                                aria-selected={aktiv === m}
                                className={'adminMenuPont' + (aktiv === m ? ' aktiv' : '')}
                                onClick={function () { setKivalasztottID(m.id); }}>
                                <FontAwesomeIcon icon={m.ikon} /> {m.felirat}
                            </button>
                        );
                    })}
                    <button type="button" className="adminKilepes" onClick={onKilepes}>
                        <FontAwesomeIcon icon="fa-right-from-bracket" /> Kilépés
                    </button>
                </div>
                <div className="adminTartalom">
                    {aktiv === undefined ?
                        <div className="adminUres">Jelenleg nincs elérhető admin oldal.</div>
                        :
                        <aktiv.Komponens callAPI={callAPI} getCommInProgress={getCommInProgress} felhasznalo={felhasznalo} />
                    }
                </div>
            </div>
        </div>
    );
}
